import {
    store
} from "..";
const myinfo = {
    userinfo: null,
    employeeinfo: null,
    myassignments: [],
    menulist: [],
    accessstatus: true
};
export default function(state = myinfo, action) {
    var assignments = [];
    switch (action.type) {
        case "RealTimeUpdate for myrealtimeinfo":
            // action.payload = action.payload[0];
            if (state.myassignments.length) {
                assignments = assempcalc(action.payload, state.myassignments);
            }
            if (
                state.employeeinfo &&
                state.employeeinfo.empnumber !== action.payload.empnumber
            ) {
                return {
                    ...state,
                    myassignments: assignments,
                    menulist: handlemenu(action.payload.jtadmin, action.payload.hradmin)
                };
            } else {
                return {
                    ...state,
                    employeeinfo: action.payload,
                    myassignments: assignments,
                    menulist: handlemenu(action.payload.jtadmin, action.payload.hradmin)
                };
            }

            break;
        case "RealTimeUpdate for assignedjobs":
            if (action.payload.data) {
                action.payload = action.payload.data;
            }
            //  console.log(action.payload);
            if (state.employeeinfo) {
                assignments = assempcalc(state.employeeinfo, action.payload);
            } else {
                assignments = action.payload;
            }
            return {
                ...state,
                myassignments: assignments
            };
            break;

        case "AccessRequest":
            if (state.employeeinfo) {
                return {
                    ...state,
                    accessstatus: !!state.employeeinfo[action.payload]
                };
            } else {
                return state;
            }
            break;
        case "AccessRenewel":
            return {
                ...state,
                accessstatus: true
            };
            break;
        default:
            return state;
    }
}

const handlemenu = (jtadmin, hradmin) => {
    let menu = genericmenu;
    if (jtadmin) {
        menu = menu.concat(
            searchestimates,
            menuworkorder,
            menujobtrack,
            menuestimates
        );
    }
    if (hradmin) {
        menu = menu.concat(
            menutnms,
            menuinvoices,
            menucustinfo,
            menuhr,
            menureports,
            
        );
    }
    return menu;
};
const assempcalc = (emp, ass) => {
    return ass.filter(
        job => job.empnumber === parseInt(emp.empnumber) && job.removed === 0
    );
};
const genericmenu = [{
        title: "Home",
        IconName: "home",
        link: "/"
    },
    {
        title: "  Time Entry",
        IconName: "hourglass start",
        link: "/time-entry"
    },

    {
        title: "Info",
        IconName: "info",
        link: "/general-info"
    },
    {
        title: "Phone Book",
        IconName: "phone",
        link: "phone-book"
    }
];

const menuworkorder = {
    title: "Work Orders",
    IconName: "tasks",
    modal: "wodsearch"
};

const menucustinfo = {
    title: "Customer Info",
    IconName: "fighter jet",
    list: [{
            name: "Billing Contacts",
            link: "/cust-info/billing"
        },
        {
            name: "Company",
            link: "/cust-info/company"
        },
        {
            name: "Location",
            link: "/cust-info/location"
        },
        {
            name: "Project",
            link: "/cust-info/project"
        },
        {
            name: "Project Manager",
            link: "/cust-info/pm"
        }
    ]
};
const menuhr = {
    title: "Human Resources",
    IconName: "smile",
    list: [{
            name: "Employees",
            link: "/hr/employees"
        },
        {
            name: "Materials",
            link: "/hr/materials"
        },
        {
            name: "Salaries",
            link: "/hr/salaries"
        }
    ]
};
const menureports = {
    title: "Reports",
    IconName: "bar chart",
    list: [{
            name: "Payroll",
            link: "/reports/payroll"
        },
        {
            name: "PTO",
            link: "/reports/pto"
        },
        {
            name: "Materials",
            link: "/reports/materials"
        },
        {
            name: "Unpaid Days",
            link: "/reports/unpaid_days"
        },
        {
            name: "Labor Report",
            link: "/reports/labor_report"
        }
    ]
};
const menuestimates = {
    title: "Create Estimate",
    IconName: "calculator",
    modal: "estimates"
};
const searchestimates = {
    title: "Manage Estimates",
    IconName: "check",
    modal: "estimatesearchmodal"
};

const menutnms = {
    title: "T&M",
    IconName: "tasks",
    list: [{
            name: "Run",
            link: "/tnms/approve"
        },
        {
            name: "Send",
            link: "/tnms/send"
        },
        {
            name: "Move Time",
            link: "/tnms/move-time"
        },
        {
            name: "Mass Delete",
            link: "/tnms/massdelete"
        }
    ]
};

const menuinvoices = {
    title: "Invoices",
    IconName: "cc visa",
    list: [{
            name: "Create",
            link: "/invoices/create"
        },
        {
            name: "Custom",
            link: "/invoices/custom"
        },
        {
            name: "Send",
            link: "/invoices/send"
        },
        {
            name: "Customer",
            link: "/invoices/customer"
        },
        {
            name: "Unpaid",
            link: "/invoices/unpaid"
        },
        {
            name: "Paid Invoices",
            link: "/invoices/paid"
        },
        {
            name: "Fixed Price",
            link: "/invoices/fixedprice"
        }, {
            name: "Search Invoices",
            modal: "invsearch"
        }, {
            name: "Annual Ledger",
            link: "/invoices/annual-ledger"
        }
    ]
};

const menujobtrack = {
    title: "Job Tracker",
    IconName: "dollar",
    list: [{
            name: "Update Job Info"
        },
        {
            name: "EditApprove Estimate"
        },
        {
            name: "Closed Jobs Assigned"
        }
    ]
};


// WEBPACK FOOTER //
// ./src/reducers/myinfo-reducer.js